import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/lib/stores/auth";
import { useRoleStore } from "@/lib/stores/role";

export function RoleRedirect() {
  // Auth store user.role is the primary source after #186 login.
  // Fall back to legacy role store for sessions established before #186.
  const authRole = useAuthStore((s) => s.user?.role);
  const legacyRole = useRoleStore((s) => s.currentRole);
  const currentRole = authRole ?? legacyRole;

  if (currentRole === "owner") return <Navigate to="/owner/dashboard" replace />;
  if (currentRole === "manager") return <Navigate to="/manager/dashboard" replace />;
  if (currentRole === "trainer") return <Navigate to="/trainer/my-referrals" replace />;
  return <Navigate to="/login" replace />;
}
